import React, { useState } from 'react'
import { Users, Package, LogOut, Key, RefreshCcw, Bell } from 'lucide-react'
import { Link, useNavigate } from 'react-router-dom'
import { path } from '../Utils/ScreenPath'
import { useSelector } from 'react-redux'
import omnicard from '../assets/images/omni.webp'
import menu from '../assets/menuicon.png'
import hi from '../assets/images/hi.png'
import fastag from '../assets/fastaglogo.png'
import Profile from '../assets/Profile.png'
import ActiveProfile from '../assets/ActiveProfile.png'
import Home from '../assets/Home.png'
import Active from '../assets/Activehome.png'
import Inventory from '../assets/Inventory.png'
import Activeinvent from '../assets/Activeinvent.png'
import FASTagRequest from '../assets/FASTagRequest.png'
import ActiveFASTagRequest from '../assets/ActiveFASTagRequest.png'
import Report from '../assets/report.png'
import Activereport from '../assets/Activereport.png'
import { ArrowRight } from 'lucide-react';
import { ClipboardList, ReceiptIndianRupee, LifeBuoy } from 'lucide-react';
import { getRole } from '../Utils/auth';
import FastagPurchase from '../Commponent/FastagPurchase';
import AgentFastagRequest from '../Commponent/AgentFastagRequest';

export default function Layout({ children }) {
    const navigate = useNavigate()
    const reduxData = useSelector((state) => state)
    const { pathname } = window.location
    const role = getRole();
    // "View Transactions" permission (default true). Non-admin roles see the
    // Transaction N menu only when this is not explicitly disabled.
    let canViewTransactions = true;
    try {
        const ud = JSON.parse(localStorage.getItem('UserDetail'));
        if (ud && ud.canViewTransactions === false) canViewTransactions = false;
    } catch (e) { /* default true */ }
    // FASTag Activation permission (default true). Its menu shows only when true.
    // let canActivateFastag = true;
    // try {
    //     canActivateFastag = JSON.parse(localStorage.getItem('UserDetail'))?.canActivateFastag !== false;
    // } catch (e) {
    //     canActivateFastag = true;
    // }
    const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
    const [showPurchaseModal, setShowPurchaseModal] = useState(false);
    let mainMenuItems = [];

    if (role === 'agent') {
        mainMenuItems = [
            {
                path: path.dashboardagent,
                icon: Home,
                activeicon: Active,
                label: 'Dashboard',
                isActive: pathname === path.dashboardagent || pathname.includes('/dashboard/agent')
            },
            // Agents can ALWAYS activate FASTags — this menu is never gated for agents.
            // {
            //     path: path.fastagactivation,
            //     icon: Profile,
            //     activeicon: ActiveProfile,
            //     label: 'FASTag Activation',
            //     isActive: pathname === path.fastagactivation || pathname.includes('/fastag/activation')
            // },
            {
                path: path.agentinventory,
                icon: Inventory,
                activeicon: Activeinvent,
                label: 'Inventory',
                isActive: pathname === path.agentinventory || pathname.includes('/agent-inventory')
            },
            {
                path: path.MyFastagRequest,
                icon: FASTagRequest,
                activeicon: ActiveFASTagRequest,
                label: 'My FASTag Request',
                isActive: pathname === path.MyFastagRequest || pathname.includes('/My-Fastag-Request')
            }
        ];
    } else if (role === 'admin') {
        mainMenuItems = [
            {
                path: path.dashboardadmin,
                icon: Home,
                activeicon: Active,
                label: 'Dashboard',
                isActive: pathname === path.dashboardadmin || pathname.includes('/dashboard/admin')
            },
            {
                path: path.fastagrequest,
                icon: FASTagRequest,
                activeicon: ActiveFASTagRequest,
                label: 'FASTag Request',
                isActive: pathname === path.fastagrequest || pathname.includes('/fastag/request')
            },
            {
                path: path.distributoradmin,
                icon: Profile,
                activeicon: ActiveProfile,
                label: 'Distributor',
                isActive: pathname === path.distributoradmin || pathname.includes('/distributor/admin')
            },
            {
                path: path.AdminInventory,
                icon: Inventory,
                activeicon: Activeinvent,
                label: 'Inventory',
                isActive: pathname === path.AdminInventory || pathname.includes('/AdminInventory')
            },
            {
                path: path.masterFastag,
                // Same icon the distributor's own Master FASTag menu uses.
                icon: ClipboardList,
                activeicon: ClipboardList,
                label: 'Master FASTag',
                isActive: pathname === path.masterFastag || pathname.includes('/master-fastag')
            },
            {
                path: path.report,
                icon: Report,
                activeicon: Activereport,
                label: 'Report',
                isActive: pathname === path.report || pathname.includes('/report')
            }
        ];
    } else if (role === 'distributor' || role === 'dealer') {
        mainMenuItems = [
            {
                path: path.dashboard,
                icon: Home,
                activeicon: Active,
                label: 'Dashboard',
                isActive: pathname === path.dashboard || pathname.includes('/dashboard')
            },
            {
                path: path.team,
                icon: Profile,
                activeicon: ActiveProfile,
                label: 'Team',
                isActive: pathname === path.team || pathname.includes('/team') || pathname.includes('/agents') || pathname.includes('/dealers')
            },
            {
                path: path.inventory,
                icon: Inventory,
                activeicon: Activeinvent,
                label: 'Inventory',
                isActive: pathname === path.inventory || pathname.includes('/inventory')
            },
            // ...(canActivateFastag ? [{
            //     path: path.fastagactivation,
            //     icon: Profile,
            //     activeicon: ActiveProfile,
            //     label: 'FASTag Activation',
            //     isActive: pathname === path.fastagactivation || pathname.includes('/fastag/activation')
            // }] : []),
            {
                path: path.MyAgentsRequest,
                icon: FASTagRequest,
                activeicon: ActiveFASTagRequest,
                label: 'FASTag Requests',
                isActive: pathname === path.MyAgentsRequest || pathname.includes('/Agents-Fastag-Request')
            }
        ];
        // Master FASTag is a distributor-only tracking view (not shown to dealers).
        if (role === 'distributor') {
            mainMenuItems.push({
                path: path.masterFastagDistributor,
                icon: ClipboardList,
                activeicon: ClipboardList,
                label: 'Master FASTag',
                isActive: pathname === path.masterFastagDistributor || pathname.includes('/distributor-master-fastag')
            });
        }
    }

    // Support is available to every role.
    if (['admin', 'distributor', 'dealer', 'agent'].includes(role)) {
        mainMenuItems.push({
            path: path.support,
            icon: LifeBuoy,
            activeicon: LifeBuoy,
            label: 'Support',
            isActive: pathname === path.support || pathname.includes('/support')
        });
    }

    // Transaction N: admin always; distributor/dealer/agent when they have the
    // "View Transactions" permission (each is scoped to their own records).
    if (role === 'admin' || (['distributor', 'dealer', 'agent'].includes(role) && canViewTransactions)) {
        mainMenuItems.push({
            path: path.transactionsN,
            icon: ReceiptIndianRupee,
            activeicon: ReceiptIndianRupee,
            label: 'Transaction ',
            isActive: pathname === path.transactionsN || pathname.includes('/transactions-n')
        });
    }
    // Transactions (legacy) — admin only (hidden/commented out).
    // if (role === 'admin') {
    //     mainMenuItems.push({
    //         path: path.transactions,
    //         icon: Receipt,
    //         activeicon: Receipt,
    //         label: 'Transactions',
    //         isActive: pathname === path.transactions || (pathname.includes('/transactions') && !pathname.includes('/transactions-n'))
    //     });
    // }

    const settingsMenuItems = [
        {
            path: path.ChangepasswordPage,
            icon: Key,
            label: 'Change Password',
            isActive: pathname === path.ChangepasswordPage || pathname.includes('/change-password')
        },
        {
            path: path.logout,
            icon: LogOut,
            label: 'Logout',
            isActive: false,
            isLogout: true
        }
    ]

    const userDetail = JSON.parse(localStorage.getItem('UserDetail'));

    const profileData = {
        name: userDetail?.username || "Your Profile",
        status: userDetail?.role || "Distributor",
        phone: userDetail?.mobileNo ? `+91 ${userDetail.mobileNo}` : '',
    };

    const handleLogout = () => {
        localStorage.removeItem('token')
        navigate(path.login)
    }

    return (
        <div className="md:flex h-screen bg-gray-50 relative">
            {/* Mobile Menu Button */}
            <div className="md:hidden flex justify-between items-center p-4 bg-white shadow-sm w-full z-50">
                {/* <img src={omnicard} alt="Logo" className="w-[98px]" /> */}
                <button
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                    className="text-gray-700 focus:outline-none"
                >
                    {/* <Bell className='h-[16px] w-[16px] justify-end' /> */}
                    <img src={menu} alt="Logo" className="w-[26px]" />
                </button>
                {/* <span className="ml-4 font-semibold text-lg">Menu</span> */}
            </div>

            {/* Backdrop */}
            {isMobileMenuOpen && (
                <div
                    className="fixed inset-0 bg-black opacity-50 z-45 md:hidden"
                    onClick={() => setIsMobileMenuOpen(false)}
                />
            )}

            {/* Sidebar */}
            <aside
                className={`bg-white w-[260px] shadow-lg border-r border-gray-100 flex flex-col justify-between fixed md:static inset-y-0 left-0 z-50 transform md:translate-x-0 transition-transform duration-300 ease-in-out
                    ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}
                `}
            >
                <div className="flex flex-col w-full flex-1 overflow-y-auto">
                    {/* Logo Section */}
                    <div className="px-[32px] pt-[32px] hidden md:block">
                        <div className="flex items-center space-x-2">
                            <div className="flex items-center">
                                <img src={omnicard} alt="Logo" className="w-[155px]" />
                            </div>
                        </div>
                    </div>

                    <div className="p-[32px] md:border-b md:border-gray-100 block  md:hidden">
                        {/* <div className="flex items-center space-x-2">
                        <div className="flex items-center">
                            <img src={omnicard} alt="Logo" className="w-[155px]" />
                        </div>
                    </div> */}

                        <div className="flex justify-center  mb-[10px]">

                            <img
                                src={hi}
                                className="mx-auto w-[54px] h-[54px] logo left"
                                onError={(e) => {
                                    e.target.style.display = 'none';
                                    e.target.nextSibling.style.display = 'block';
                                }}
                            />

                            <div className="text-center mb-[10px]">
                                <h4 className="text-[24px] font-bold text-gray-900 mb-1">{profileData.status}</h4>
                                <p className="text-[#1F1715]  fontWeight-[600] text-[16px]">{profileData.phone}</p>
                            </div>
                        </div>

                    </div>



                    {/* Desktop Navigation */}
                    <nav className="flex-1 px-[32px] py-[20px] hidden md:block">
                        <div className="space-y-2">
                            {mainMenuItems.map((item) => {
                                const IconComponent = item.icon
                                return (
                                    <Link
                                        key={item.path}
                                        to={item.path}
                                        onClick={() => setIsMobileMenuOpen(false)}
                                        className={`flex items-center space-x-3  py-3 rounded-lg transition-all duration-200 group ${item.isActive
                                            ? ' text-red-600 '
                                            : 'text-black-600 hover:bg-black-50 hover:text-gray-900'
                                            }`}
                                    >
                                        {typeof item.icon === 'string' ? (
                                            <img
                                                src={item.isActive ? item?.activeicon : item.icon}
                                                alt={item.icon}
                                                className={`w-5 h-5 ${item.isActive
                                                    ? 'text-red-500'
                                                    : 'text-[#1F1715] group-hover:text-black-600'
                                                    }`}
                                            />
                                        ) : (
                                            <item.icon className={`w-5 h-5 ${item.isActive ? 'text-red-600' : 'text-[#1F1715]'}`} />
                                        )}
                                        <span className={` ${item.isActive ? 'text-[#EE3B31]' : ''}`}>{item.label}</span>
                                    </Link>
                                )
                            })}
                        </div>
                    </nav>
                    {/* Settings Section */}
                    <div className="block md:hidden md:px-4  md:py-6 px-[32px] md:border-t md:border-gray-100">
                        {role === 'admin' && (
                            <div className="mb-4">
                                <span className="text-[16px] font-[600] text-gray-900 uppercase tracking-wider">
                                    SETTINGS
                                </span>
                            </div>
                        )}
                        <div className="space-y-2">
                            {settingsMenuItems.map((item) => {
                                const IconComponent = item.icon
                                if (item.isLogout) {
                                    return (
                                        <>
                                            <button
                                                key={item.path}
                                                onClick={() => {
                                                    setIsMobileMenuOpen(false);
                                                    setShowLogoutConfirm(true); // Open confirmation popup
                                                }}
                                                className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 text-gray-600 hover:bg-gray-50 hover:text-gray-900 group"
                                            >
                                                <LogOut className="text-[#1F1715]" />
                                                <span className="text-[#1F1715]">{item.label}</span>
                                            </button>

                                        </>
                                    )
                                }
                                return (
                                    <Link
                                        key={item.path}
                                        to={item.path}
                                        onClick={() => setIsMobileMenuOpen(false)}
                                        className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 group ${item.isActive
                                            ? 'bg-red-50 text-red-600 border-r-2 border-red-500'
                                            : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                                            }`}
                                    >
                                        <RefreshCcw className="text-[#1F1715]" />
                                        <span
                                            className={` ${item.isActive ? 'text-red-600' : 'text-[#1F1715]'
                                                }`}
                                        >
                                            {item.label}
                                        </span>
                                    </Link>
                                )
                            })}
                        </div>
                    </div>

                </div>


                {/* destop screen  */}
                <div className='w-full flex flex-col gap-[40px] md:gap-0 mb-[32px] md:mb-0 flex-shrink-0'>

                    <div className=" md:block hidden  md:py-6 px-[32px] md:border-t md:border-gray-100">
                        {role === 'admin' && (
                            <div className="mb-4">
                                <span className="text-[16px] font-[600] text-gray-900 uppercase tracking-wider">
                                    SETTINGS
                                </span>
                            </div>
                        )}
                        <div className="space-y-2">
                            {settingsMenuItems.map((item) => {
                                const IconComponent = item.icon
                                if (item.isLogout) {
                                    return (
                                        <>
                                            <button
                                                key={item.path}
                                                onClick={() => {
                                                    setIsMobileMenuOpen(false);
                                                    setShowLogoutConfirm(true); // Open confirmation popup
                                                }}
                                                className="w-full flex  items-center space-x-3  py-3 rounded-lg transition-all duration-200 text-gray-600 hover:bg-gray-50 hover:text-gray-900 group"
                                            >
                                                <LogOut className="text-[#1F1715]" />
                                                <span className="text-[#1F1715]">{item.label}</span>
                                            </button>

                                        </>
                                    )
                                }
                                return (
                                    <Link
                                        key={item.path}
                                        to={item.path}
                                        onClick={() => setIsMobileMenuOpen(false)}
                                        className={`flex items-center space-x-3 py-3 rounded-lg transition-all duration-200 group ${item.isActive ? 'text-red-600 ' : 'text-[#1F1715]'
                                            }`}
                                    >
                                        <RefreshCcw className="w-5 h-5" />
                                        <span>
                                            {item.label}
                                        </span>
                                    </Link>

                                )
                            })}
                        </div>
                    </div>
                    <div className='w-full px-[32px]'>

                        {role === 'agent' ? (
                            <button
                                className="block md:hidden w-full bg-green-500 hover:bg-green-600 text-white py-[11px] rounded-full font-medium flex items-center justify-center space-x-2 transition-colors"
                                onClick={() => setShowPurchaseModal(true)}
                            >
                                <span className="text-[14px] font-[700] mr-3">Raise FASTag Request</span>
                                <ArrowRight className="!w-[16px] !h-[16px]" />
                            </button>
                        ) : (
                            <button
                                className="block md:hidden w-full bg-green-500 hover:bg-green-600 text-white py-[11px] rounded-full  font-medium flex items-center justify-center space-x-2 transition-colors"
                                onClick={() => setShowPurchaseModal(true)}
                            >
                                <span className="text-[14px] font-[700] mr-3">Purchase FASTag</span>
                                <ArrowRight className="!w-[16px] !h-[16px]" />
                            </button>
                        )}
                    </div>

                    <div className="text-center">
                        <img
                            src={fastag}
                            // alt="NETC FASTag Logo" 
                            className="mx-auto w-[174px] logo left block md:hidden"
                            onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.nextSibling.style.display = 'block';
                            }}
                        />
                    </div>
                    <div className="flex items-center justify-center md:hidden">
                        <img src={omnicard} alt="Logo" className="h-[40px] max-w-full" />
                    </div>
                </div>
            </aside>

            {/* Main Content Area */}
            <div className="flex-1 flex flex-col overflow-hidden">
                <main className="flex-1 overflow-x-auto overflow-y-auto bg-[#F8F8F8] p-[20px]">
                    {children}
                </main>
                <footer className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 shadow-lg z-30 md:hidden">
                    <nav className="px-1 py-2">
                        <div className="flex justify-between items-center">
                            {mainMenuItems.map((item) => {
                                // Shorten text for better display
                                const shortLabel = item.label === 'Dashboard' ? 'Dashbo..' :
                                    item.label === 'FASTag Request' ? 'FASTag..' :
                                        item.label === 'FASTag Activation' ? 'FASTag..' :
                                            item.label === 'Distributor' ? 'Distribu..' :
                                                item.label === 'Master FASTag Inventory' ? 'Master..' :
                                                    item.label === 'Inventory' ? 'Inventory' :
                                                        item.label === 'Report' ? 'Report' :
                                                            item.label === 'Agents' ? 'Agents' :
                                                                item.label === 'AdminSetting' ? 'Admin..' :
                                                                    item.label;

                                return (
                                    <Link
                                        key={item.path}
                                        to={item.path}
                                        onClick={() => setIsMobileMenuOpen(false)}
                                        className={`flex flex-col items-center justify-center px-1 py-1 rounded-lg transition-all duration-200 flex-1 min-w-0 ${item.isActive
                                            ? 'text-red-600'
                                            : 'text-gray-600 hover:text-gray-900'
                                            }`}
                                    >
                                        <div className="flex flex-col items-center justify-center h-12">
                                            {typeof item.icon === 'string' ? (
                                                <img
                                                    src={item.isActive ? item?.activeicon : item.icon}
                                                    alt={item.label}
                                                    className="w-5 h-5 mb-1 flex-shrink-0"
                                                />
                                            ) : (
                                                <item.icon className={`w-5 h-5 mb-1 flex-shrink-0 ${item.isActive ? 'text-red-600' : 'text-gray-600'}`} />
                                            )}
                                            <span className={`text-xs font-medium text-center leading-none ${item.isActive ? 'text-[#EE3B31]' : 'text-gray-600'}`}>
                                                {shortLabel}
                                            </span>
                                        </div>
                                    </Link>
                                )
                            })}
                        </div>
                    </nav>
                </footer>
            </div >
            {showLogoutConfirm && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center">
                    <div className="bg-white rounded-xl shadow-md p-6 w-[90%] max-w-sm text-center">
                        <h2 className="text-xl font-semibold mb-4">Are you sure you want to logout?</h2>
                        <div className="flex justify-center space-x-4">
                            <button
                                onClick={() => setShowLogoutConfirm(false)}
                                className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-4 py-2 rounded"
                            >
                                No
                            </button>
                            <button
                                onClick={() => {
                                    setShowLogoutConfirm(false);
                                    handleLogout();
                                }}
                                className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded"
                            >
                                Yes
                            </button>

                        </div>
                    </div>
                </div>
            )}

            {showPurchaseModal && role === 'distributor' && (
                <FastagPurchase onClose={() => setShowPurchaseModal(false)} />
            )}

            {showPurchaseModal && (role === 'agent' || role === 'dealer') && (
                <AgentFastagRequest onClose={() => setShowPurchaseModal(false)} />
            )}

        </div >
    )
}
